export interface MembershipFee {
  id: number;
  playerId: number;
  playerName: string;
  ageGroup: string;
  year: number;
  month: number;
  amount: number;
  isPaid: boolean;
  paidAt?: string;
  markedPaidByUserName?: string;
  lastReminderSentAt?: string | null;
  createdAt: string;
}

export interface MembershipFeeSettings {
  id: number;
  defaultMonthlyAmount: number;
  /** Menjen-e havonta automatikus emlékeztető a tartozóknak. */
  reminderEnabled: boolean;
  /** A hónap hányadik napján (1-28). */
  reminderDayOfMonth: number;
  updatedAt: string;
  updatedByUserName?: string;
}

export interface UpdateFeeSettingsRequest {
  defaultMonthlyAmount: number;
  reminderEnabled?: boolean;
  reminderDayOfMonth?: number;
}

export interface FeeReminderResult {
  /** Hány játékos tartozásáról ment értesítés. */
  playerCount: number;
  /** Hány szülő / játékos kapta meg. */
  recipientCount: number;
  /** Hány tartozónak nincs elérhető fiókja. */
  playersWithoutRecipient: number;
}

/** Tagdíj generálás: egész klub (üres listák), korosztályok és/vagy játékosok. */
export interface GenerateFeesRequest {
  year: number;
  month: number;
  ageGroupIds?: number[];
  playerIds?: number[];
  /** Mindenkinek ez az összeg; nincs megadva = egyedi díj, ennek híján az alapértelmezett. */
  amount?: number | null;
}

export interface FeeGenerationLine {
  playerId: number;
  playerName: string;
  ageGroup: string;
  amount: number;
}

export interface FeeGenerationResult {
  lines: FeeGenerationLine[];
  totalAmount: number;
  /** Akiknek erre a hónapra már van tagdíja. */
  alreadyExistsCount: number;
  /** Akiknél 0 Ft jönne ki - nekik nem készül tagdíj. */
  zeroAmountPlayers: string[];
  /** Generáláskor a létrehozott tételek száma (előnézetnél 0). */
  createdCount: number;
}

export interface SendFeeRemindersRequest {
  playerIds?: number[];
  ageGroupIds?: number[];
  sendEmail: boolean;
  sendPush: boolean;
}

export interface UpdatePlayerFeeOverrideRequest {
  customMonthlyFee: number | null;
}

export interface MarkFeePaymentRequest {
  isPaid: boolean;
}

export interface FeeStatistics {
  year: number;
  month: number;
  totalPlayers: number;
  paidCount: number;
  unpaidCount: number;
  totalExpected: number;
  totalCollected: number;
  totalOutstanding: number;
  byAgeGroup: FeeAgeGroupBreakdown[];
}

export interface FeeAgeGroupBreakdown {
  ageGroupName: string;
  totalPlayers: number;
  paidCount: number;
  unpaidCount: number;
  totalExpected: number;
  totalCollected: number;
}

export interface ChildFeeOverview {
  playerId: number;
  playerName: string;
  customMonthlyFee?: number;
  fees: MembershipFee[];
}

export interface OutstandingFees {
  totalOutstanding: number;
  unpaidCount: number;
  byPlayer: OutstandingPlayer[];
  byAgeGroup: FeeAgeGroupBreakdown[];
}

export interface OutstandingPlayer {
  playerId: number;
  playerName: string;
  ageGroup: string;
  outstandingAmount: number;
  unpaidMonths: number;
  lastReminderSentAt?: string | null;
}

export const MONTH_NAMES = [
  'Január', 'Február', 'Március', 'Április', 'Május', 'Június',
  'Július', 'Augusztus', 'Szeptember', 'Október', 'November', 'December',
];
